import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ResetPasswordVerifyFormProps {
    formData: {
        verificationCode: string;
        newPassword?: string;
    };
    showPassword: boolean;
    setShowPassword: (show: boolean) => void;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isDrawer?: boolean;
}

export const ResetPasswordVerifyForm: React.FC<ResetPasswordVerifyFormProps> = ({
    formData,
    showPassword,
    setShowPassword,
    handleInputChange,
    isDrawer
}) => {
    return (
        <div className={cn("space-y-4", isDrawer ? "px-4" : "")} dir="rtl">
            <div className="space-y-2">
                <Label htmlFor="verificationCode">קוד אימות</Label>
                <Input
                    id="verificationCode"
                    name="verificationCode"
                    type="text"
                    value={formData.verificationCode}
                    onChange={handleInputChange}
                    placeholder="הכנס את קוד האימות (6 ספרות)"
                    required
                    className="text-center text-2xl tracking-widest"
                    dir="ltr"
                    maxLength={6}
                    pattern="[0-9]{6}"
                    autoFocus={false}
                />
            </div>
            <div className="space-y-2">
                <Label htmlFor="newPassword">סיסמה חדשה</Label>
                <div className="relative">
                    <Input
                        id="newPassword"
                        name="newPassword"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.newPassword || ''}
                        onChange={handleInputChange}
                        placeholder="לפחות 6 תווים עם אות ומספר"
                        required
                        className="text-right pl-10"
                        dir="rtl"
                        minLength={6}
                    />
                    <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 p-0 hover:bg-muted"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        <span className="sr-only">
                            {showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'}
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    );
};
